import axios from "axios";

export function handleApiError(
  err: unknown,
  defaultMessage: string,
  customMessages?: Partial<Record<number, string>>
): string {
  let errorMessage = defaultMessage;

  if (axios.isAxiosError(err)) {
    const status = err.response?.status;
    const backendMessage = err.response?.data?.message;

    if (status && customMessages?.[status]) {
      errorMessage = customMessages[status];
    } else if (status === 401) {
      errorMessage = "Неверный логин или пароль.";
    } else if (status === 403) {
      if (backendMessage.includes("Access denied to IP address")) {
        errorMessage = "Доступ ограничен. Попробуйте включить VPN";
      }
    } else if (status === 404) {
      errorMessage = "Ресурс не найден.";
    } else if (backendMessage) {
      errorMessage = backendMessage;
    }
  } else if (err instanceof Error) {
    errorMessage = err.message || defaultMessage;
  }

  console.error(err);
  return errorMessage;
}
